import { addImageParams } from '@/utils/urls';

const IMAGE_QUALITY = 100;
const BANNER_IMAGE_HEIGHT = 240;

const BANNER_IMAGE_BASE_URL = 'https://p1.liveauctioneers.com/dist/images/htw_homepage_banner_asset.png';
const HERO_BANNER_IMAGE_BASE_URL = 'https://p1.liveauctioneers.com/dist/images/htw_hero_banner_image.png';
const STEP_1_VISUAL_BASE_URL = 'https://p1.liveauctioneers.com/dist/images/htw_step_1_visual.png';
const STEP_2_VISUAL_BASE_URL = 'https://p1.liveauctioneers.com/dist/images/htw_step_2_visual.png';
const STEP_3_VISUAL_BASE_URL = 'https://p1.liveauctioneers.com/dist/images/htw_step_3_visual.png';
const STEP_4_VISUAL_BASE_URL = 'https://p1.liveauctioneers.com/dist/images/htw_step_4_visual.png';
const STEP_5_VISUAL_BASE_URL = 'https://p1.liveauctioneers.com/dist/images/htw_step_5_visual.png';

export const BANNER_GRADIENT_STYLE = {
    background: 'linear-gradient(88deg, rgba(0, 155, 204, 0.30) 0%, rgba(236, 250, 255, 0.30) 100.84%), #C6F1FF',
} as const;

const imageParams = { quality: IMAGE_QUALITY, sharpen: true } as const;

export const BANNER_IMAGE_URL = addImageParams({
    ...imageParams,
    height: BANNER_IMAGE_HEIGHT,
    url: BANNER_IMAGE_BASE_URL,
});

export const HOW_TO_WIN_HERO_BANNER_IMAGE_URL = addImageParams({
    ...imageParams,
    url: HERO_BANNER_IMAGE_BASE_URL,
});

export const HOW_TO_WIN_STEP_1_VISUAL_URL = addImageParams({
    ...imageParams,
    url: STEP_1_VISUAL_BASE_URL,
});

export const HOW_TO_WIN_STEP_2_VISUAL_URL = addImageParams({
    ...imageParams,
    url: STEP_2_VISUAL_BASE_URL,
});

export const HOW_TO_WIN_STEP_3_VISUAL_URL = addImageParams({
    ...imageParams,
    url: STEP_3_VISUAL_BASE_URL,
});

export const HOW_TO_WIN_STEP_4_VISUAL_URL = addImageParams({
    ...imageParams,
    url: STEP_4_VISUAL_BASE_URL,
});

export const HOW_TO_WIN_STEP_5_VISUAL_URL = addImageParams({
    ...imageParams,
    url: STEP_5_VISUAL_BASE_URL,
});
